import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import Divider from "components/divider/divider";
import CardProfile from "components/card/cardProfile/cardProfile";
import UseContext from "hooks/useContext";
import EndOfMissionDocumentRow from "pages/content/justificatifs/endOfMissionDocuments/EndOfMissionDocumentRow";
import PendingDocumentModal from "pages/content/justificatifs/endOfMissionDocuments/PendingDocumentModal";
import UnopenedBadge from "pages/content/justificatifs/endOfMissionDocuments/UnopenedBadge";
import {
    formatMonthTitle,
    groupDocumentsByMonth,
    translateEndOfMission,
} from "pages/content/justificatifs/endOfMissionDocuments/endOfMissionTexts";

// The list is loaded once by the justificatifs page (useEndOfMissionDocuments) and
// passed as a prop on desktop, or through the Outlet context on the mobile child route.
const EndOfMissionDocuments = ({ endOfMissionDocuments }) => {
    const { language } = UseContext();
    const outletContext = useOutletContext();
    const source = endOfMissionDocuments ?? outletContext?.endOfMissionDocuments;
    const [pendingDocument, setPendingDocument] = useState(null);

    const documents = source?.documents ?? [];
    if (documents.length === 0) return null;

    return (
        <CardProfile>
            <div className="flex items-center justify-between gap-3">
                <div className="flex flex-col gap-1">
                    <div className="ft-b text-gray-900">
                        {translateEndOfMission(language, "title", "Documents de fin de mission")}
                    </div>
                    <div className="ft-sm text-gray-500">
                        {translateEndOfMission(language, "subtitle", "Certificats de travail, attestations France Travail")}
                    </div>
                </div>
                <UnopenedBadge count={source.unopenedCount}/>
            </div>
            <div className={"my-5"}>
                <Divider w={100}/>
            </div>
            {groupDocumentsByMonth(documents).map((group) => (
                <div key={group.payMonth} className="mb-4">
                    <div className="ft-sm font-semibold text-gray-900 pb-2">
                        {formatMonthTitle(language, group.payMonth)}
                    </div>
                    <Divider w={100}/>
                    {group.documents.map((document) => (
                        <React.Fragment key={document._id}>
                            <EndOfMissionDocumentRow
                                document={document}
                                onOpen={source.markDocumentOpened}
                                onShowPending={setPendingDocument}
                            />
                            <Divider w={100}/>
                        </React.Fragment>
                    ))}
                </div>
            ))}
            <PendingDocumentModal document={pendingDocument} onClose={() => setPendingDocument(null)}/>
        </CardProfile>
    );
};

export default EndOfMissionDocuments;
